module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_BatteryCharging_16"],"polygon":[{"$":{"points":"0 12 8 12 0 7 0 12","fill":"#464646"}},{"$":{"points":"6 4 0 4 0 7 6 8 6 4","fill":"#464646"}},{"$":{"points":"14 6 14 4 6 4 15 9 8 8 8 12 14 12 14 10 16 10 16 6 14 6","fill":"#464646"}},{"$":{"points":"6 4 0 4 0 7 6 8 6 4","fill":"#464646"}}],"path":[{"$":{"d":"M0,7l8,5H0ZM14,6V4H6l9,5L8,8v4h6V10h2V6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_BatteryCharging_16.svg
// module id = 7ccb
// module chunks = 1